import React from "react";
import { useTranslation } from "react-i18next";
import { DateFilter } from "../utils/date-utils";

interface DateFilterTabsProps {
  selectedFilter: DateFilter;
  onFilterChange: (filter: DateFilter) => void;
  className?: string;
}

const DateFilterTabs: React.FC<DateFilterTabsProps> = ({
  selectedFilter,
  onFilterChange,
  className = "",
}) => {
  const { t } = useTranslation();
  const filters = [
    { value: DateFilter.All, label: t("sessions.filters.all") },
    { value: DateFilter.Today, label: t("sessions.filters.today") },
    { value: DateFilter.ThisWeek, label: t("sessions.filters.thisWeek") },
    { value: DateFilter.ThisMonth, label: t("sessions.filters.thisMonth") },
  ];

  return (
    <div className={`flex max-w-[698px] flex-wrap gap-4 ${className}`.trim()}>
      {filters.map((filter) => (
        <label key={filter.value} className="flex cursor-pointer">
          <input
            type="radio"
            name="dateFilter"
            value={filter.value}
            className="peer hidden"
            checked={selectedFilter === filter.value}
            onChange={() => onFilterChange(filter.value)}
          />
          <span className="checkbox-group-item py-0">{filter.label}</span>
        </label>
      ))}
    </div>
  );
};

export default DateFilterTabs;
